import { useContext } from 'react'
import { AuthContext } from './context.ts'

export function useAuthContext() {
  return useContext(AuthContext)
}

export function useAuthUser() {
  const { authUser } = useAuthContext()
  return authUser
}

export function useEnsureAuthUser() {
  const authUser = useAuthUser()
  if (!authUser) throw new Error('User must be available')
  return authUser
}

export function useAuthUserProfile() {
  return useAuthContext().authUser?.profile
}

export function useAuthUserId() {
  return useAuthUserProfile()?.sub
}

export function useEnsureAuthUserId() {
  return useEnsureAuthUser().profile.sub
}
